import { Configuration, InteractionType, LogLevel } from "@azure/msal-browser";
import { environment } from "./environments/environment";
import { MsalInterceptorConfiguration } from "@azure/msal-angular";

export const clientId = '6f4a7291-9359-4d8e-a0b8-bab7d671adfd';
export const tenantId = '5b15ae4d-f706-4301-8c50-87a6fe01284f';
export const redirectUri = environment.redirectUri;
export const redirectUriLogout = environment.redirectUriLogout;

export const OAuthSettings = {
    appId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`, // remplace <TENANT_ID> par ton tenant Azure AD
    redirectUri: environment.redirectUri,
    redirectUriLogout: environment.redirectUriLogout,

    scopes: [
      "user.read",
      "mailboxsettings.read",
      "calendars.readwrite"
    ]
  };


  export const protectedResourceMap: [string, string[]][] = [
    ['https://graph.microsoft.com/v1.0/me', ['user.read']]
  ];
  
  const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
  
  export const msalConfig: Configuration = {
    auth: {
      clientId: clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: redirectUri,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
    },
    system: {
      loggerOptions: {
        loggerCallback(logLevel: LogLevel, message: string) {
          if (logLevel <= LogLevel.Warning) {
            console.log(message);
          }
        },
        logLevel: LogLevel.Warning,  // Verbose → Warning : évite les logs à chaque inspection
        piiLoggingEnabled: false
      }
    }
  };
  
  export const msalInterceptorConfig: MsalInterceptorConfiguration = {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map(protectedResourceMap)
  };